<template>
	<div class="ReCallsObjMap"
		
	>
		<yandex-map
			:settings="yamap_settings"
			:coords="yamap_coords"
			:zoom="yamap_zoom"
			:controls="yamap_controls"
			:scroll-zoom="true"
			:cluster-options="clusterOptions"
			:use-html-in-layout="true"
			
			>
				<ymap-marker v-for="marker in yamap_markers" :key="marker.id"
					:coords="marker.coords"
					:marker-id="marker.id"
					:icon="{color: marker.markerColor, content: marker.houseClassMarker}"
					:balloon-template="marker.balloonTemplate"
					:balloon="marker.clusterBalloonTemplate"
					cluster-name="cluster"
				/>
		</yandex-map>
		<!--pre style="max-width:1000px;">{{objData}}</pre-->
	</div>
</template>

<script>
	import { yandexMap, ymapMarker } from 'vue-yandex-maps';
	export default {
		name: 'ReCallsObjMap',
		components: { 
			yandexMap, 
			ymapMarker
		},
		props: {
			objData: [Object,Array]
		},
		data () {
			return {
				ver: 1,
				yamap_settings: {
					apiKey: '',
					lang: 'ru_RU',
					coordorder: 'latlong',
					version: '2.1'
				},
				yamap_coords: [59.93984485554249, 30.314527237792984],
				yamap_zoom: 11,
				yamap_controls:['zoomControl','typeSelector'],
				yamap_markers:[],
				clusterOptions: {
					clusterDisableClickZoom: true,
					clusterOpenBalloonOnClick: true,
				},
				updateTimer:null,
				fullscreenLoading: false,
			}
		},
		watch: {
			// если следим за пропсом objData здесь, то происходит двойной вызов (mounted тут не влияет, если вызов в mounted закомментить, то на Watch вызов все равно задублируется)

			objData(val){
				//console.log('watch objData to log');
				this.makeMarkers();
			}
		},
		methods: {
			makeMarkers(){
				// console.log('remove markers', this.yamap_markers.length);
				this.yamap_markers = [];
				let markers=[];
				const objGetParams = this.$GVO.GetAllGet();
				// console.log('without Watch objData to log');
				
				for (let i = 0; i < this.objData.length; i++) {
					let objSecond = this.objData[i];

					let houseClassMarker = objSecond.result_name;
					if(objSecond.result_name == '') {houseClassMarker = 'Не классифицировано';}					
					let markerColor = 'violet';

					if(objSecond.result_id == '1'){
						markerColor = 'grey';
					}else if(objSecond.result_id == '2') {
						markerColor = 'lightBlue';
					}else if(objSecond.result_id == '3') {
						markerColor = 'orange';
					}else if(objSecond.result_id == '4') {
						markerColor = 'green';
					}else if(objSecond.result_id == '5') {
						markerColor = 'blue';
					}else if(objSecond.result_id == '6') {
						markerColor = 'yellow';
					}else if(objSecond.result_id == '7') {
						markerColor = 'black';
					}else if(objSecond.result_id == '8') {
						markerColor = 'red';
					}else if(objSecond.result_id == '') {
						markerColor = 'grey';
					}


					let callAgain = '';

					// if(objSecond.result_id == 3){
					// 	callAgain = `<p>Назначен новый звонок на 00.00.000000</p>`;
					// }

					let metroBaloon = '';
					if(objSecond.metroName){
						metroBaloon = `<div class="metroPathTime">
											<i class="tim-ic ic-metro mr-2 text-primary"></i>
											<p class="">${objSecond.metroName}</p>
										</div>`
					}else metroBaloon = '';
					let strConstGetParams = '';
					if(typeof objGetParams.task_id != 'undefined' && typeof objGetParams.taskend_id != 'undefined' && typeof objGetParams.client_id != 'undefined'){
						strConstGetParams = `?task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
					}
					let strObjUrl = '/data/module/sso/object/second/'+objSecond.id;
					//let strComplexUrl = '/data/module/sso/object/complex/'+objSecond.gk_name_tr+strConstGetParams;

					let ccResult = '';
					if(objSecond.result_name != null || objSecond.result_name != undefined){
						ccResult = `
							<p>Классификация: ${objSecond.result_name}</p> 
							<p>Примечание: ${objSecond.result_descr}</p> 
						`
					}else ccResult = '<p>Классификация: не классифицировано</p>';

					let ccResultScndBubble = '';
					if(objSecond.result_name != null || objSecond.result_name != undefined){
						ccResultScndBubble = objSecond.result_name; 
					}else ccResultScndBubble = 'Не классифицировано';

					markers.push({
						id: i,
						markerId: i,
						coords: [objSecond.latitude, objSecond.longitude],
						markerColor: markerColor,
						houseClassMarker: houseClassMarker,
						clusterBalloonTemplate: {
							header: 'ID: ' + objSecond.id + ', Адрес: ' + objSecond.address,
							body: [
								['Цена: ' + this.$GVO.number_format(objSecond.price,0,'.',' ') + ' ₽', 
								'Источник: ' + objSecond.source, 
								'Классификация: ' + ccResultScndBubble,
								'<a href="/data/ColdCall/id/'+ objSecond.id +'">Посмотреть объект № ' +objSecond.id+ '</a>'
								].join('<br/>'),
							],
						},
						balloonTemplate: `
							<div class="cardComplex" style="height: auto !important;">
								<div class="img">
									<a href="/data/ColdCall/id/${objSecond.id}">
										<img alt="${objSecond.title}" onerror="this.src='/img/flatsDefault.svg'; this.onerror=''" title="${objSecond.title}" src="${objSecond.mainPhoto}">
									</a>
								</div>
												
								<div class="objInfo">
									<div class="dev"><a href="/data/ColdCall/id/${objSecond.id}">${objSecond.title}</a></div>
									<div class="price"><p>Цена: ${this.$GVO.number_format(objSecond.price,0,'.',' ')} ₽</p></div>
									<div class="address">
										${metroBaloon}
									</div>
									<div class="source">
										<a href="${objSecond.url}" target="__blank">Источник: ${objSecond.source}</a>
									</div>
									<div class="dopInfo">
										${ccResult}
										${callAgain}
									</div>
								</div>
							</div>
						`
					});

				}
				// console.log('add markers',markers.length);
				setTimeout(()=>{
					this.yamap_markers = markers;
				})
				
			},
			showlink(id){
				alert( id );
				// console.log(id);
			},
			// openFullScreen1() {
			// this.fullscreenLoading = true;
			// setTimeout(() => {
			// this.fullscreenLoading = false;
			// }, 2000);
			// },
		},
		mounted() {
			this.makeMarkers();
		},
		created(){
			
		}
	}
</script>
<style>
	.ymap-container{height: 600px; width: 100%;}
	.ReCallsObjMap{position: relative; width: 100%;}
	.cardComplex .img{
		width: 100%;
		margin: 0 auto;
    	display: flex;
		margin-bottom: 15px;
		padding-top: 15px;
	}
	.cardComplex .img img{max-width: 300px; object-fit: cover;}
	.cardComplex .img a{display: inline-block; margin: 0 auto;}
	.cardComplex p {color: #000;}
	.objAddress {margin-bottom: 5px;}
	.metroPathTime, .districtStreet {display: flex; align-items: center;}
	.objInfo {padding: 0px 10px;}
	.flatCount {margin-bottom: 5px;}
	.ymaps-2-1-77-balloon__content{
		margin-right: 0px!important;
		padding: 20px!important;
	}
    .dopInfo {
        padding-top: 10px;
        border-top: 1px solid #01b0e0;
    }
	/*===media===============================*/
	@media (max-width: 768px) {	
		.ymap-container {height: 450px;}
	}
</style>
